// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/optimize_vision_board_prompt.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/optimize_vision_board_prompt.proto.
 */
export const file_vision_generations_v1_optimize_vision_board_prompt: GenFile = /*@__PURE__*/
  fileDesc("Cjh2aXNpb24vZ2VuZXJhdGlvbnMvdjEvb3B0aW1pemVfdmlzaW9uX2JvYXJkX3Byb21wdC5wcm90bxIccHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MSKTAQogT3B0aW1pemVWaXNpb25Cb2FyZFByb21wdFJlcXVlc3QSVQoGcGFyYW1zGAEgASgLMkUucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5PcHRpbWl6ZVZpc2lvbkJvYXJkUHJvbXB0UmVxdWVzdC5QYXJhbXMaGAoGUGFyYW1zEg4KBnByb21wdBgBIAEoCSKfAQohT3B0aW1pemVWaXNpb25Cb2FyZFByb21wdFJlc3BvbnNlElYKBnJlc3VsdBgBIAEoCzJGLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuT3B0aW1pemVWaXNpb25Cb2FyZFByb21wdFJlc3BvbnNlLlJlc3VsdBoiCgZSZXN1bHQSGAoQb3B0aW1pemVkX3Byb21wdBgBIAEoCWIGcHJvdG8z");

/**
 * @generated from message protos.vision.generations.v1.OptimizeVisionBoardPromptRequest
 */
export type OptimizeVisionBoardPromptRequest = Message<"protos.vision.generations.v1.OptimizeVisionBoardPromptRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.OptimizeVisionBoardPromptRequest.Params params = 1;
   */
  params?: OptimizeVisionBoardPromptRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.OptimizeVisionBoardPromptRequest.
 * Use `create(OptimizeVisionBoardPromptRequestSchema)` to create a new message.
 */
export const OptimizeVisionBoardPromptRequestSchema: GenMessage<OptimizeVisionBoardPromptRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_optimize_vision_board_prompt, 0);

/**
 * @generated from message protos.vision.generations.v1.OptimizeVisionBoardPromptRequest.Params
 */
export type OptimizeVisionBoardPromptRequest_Params = Message<"protos.vision.generations.v1.OptimizeVisionBoardPromptRequest.Params"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;
};

/**
 * Describes the message protos.vision.generations.v1.OptimizeVisionBoardPromptRequest.Params.
 * Use `create(OptimizeVisionBoardPromptRequest_ParamsSchema)` to create a new message.
 */
export const OptimizeVisionBoardPromptRequest_ParamsSchema: GenMessage<OptimizeVisionBoardPromptRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_optimize_vision_board_prompt, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.OptimizeVisionBoardPromptResponse
 */
export type OptimizeVisionBoardPromptResponse = Message<"protos.vision.generations.v1.OptimizeVisionBoardPromptResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.OptimizeVisionBoardPromptResponse.Result result = 1;
   */
  result?: OptimizeVisionBoardPromptResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.OptimizeVisionBoardPromptResponse.
 * Use `create(OptimizeVisionBoardPromptResponseSchema)` to create a new message.
 */
export const OptimizeVisionBoardPromptResponseSchema: GenMessage<OptimizeVisionBoardPromptResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_optimize_vision_board_prompt, 1);

/**
 * @generated from message protos.vision.generations.v1.OptimizeVisionBoardPromptResponse.Result
 */
export type OptimizeVisionBoardPromptResponse_Result = Message<"protos.vision.generations.v1.OptimizeVisionBoardPromptResponse.Result"> & {
  /**
   * @generated from field: string optimized_prompt = 1;
   */
  optimizedPrompt: string;
};

/**
 * Describes the message protos.vision.generations.v1.OptimizeVisionBoardPromptResponse.Result.
 * Use `create(OptimizeVisionBoardPromptResponse_ResultSchema)` to create a new message.
 */
export const OptimizeVisionBoardPromptResponse_ResultSchema: GenMessage<OptimizeVisionBoardPromptResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_optimize_vision_board_prompt, 1, 0);

